<p-dialog
  [(visible)]="isExporting"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(92vw, 28rem)' }"
  styleClass="export-progress-dialog">
  <ng-template pTemplate="header">
    <span>{{exportDialogTitle}}</span>
  </ng-template>
  <div class="export-progress-content">
    <p class="export-progress-message">{{exportDialogMessage}}</p>
    @if (exportProgressMode === 'determinate') {
      <p-progressbar [value]="exportProgress"></p-progressbar>
      <p class="export-progress-status">{{exportStatus || 'Starting export...'}}</p>
    } @else {
      <p-progressbar mode="indeterminate" [style]="{ height: '0.75rem' }"></p-progressbar>
    }
  </div>
</p-dialog>

<div class="container">

  <!--<button (click)="exportAllAuditResults()">test</button>-->
  <div class="flex  lg:pb-4 p-2 justify-between" [ngClass]="{'hidden':!showList}">
    <h1 class="">{{ 'audit' | customerTerm }} Results</h1>
    @if (hasCampaignPermission) {
      <div class="w-full sm:w-[26rem]">
        <div class="flex justify-center items-center md:mt-3 w-full">
          <div class="flex justify-center items-center border-grey-500 border-[1px] w-1/2 hover:cursor-pointer   rounded-l-full px-4"
            [ngClass]="{'campaign-switcher':!campaignMode}" (click)="showCampaign(false)">
            <span class="whitespace-nowrap"
            [ngClass]="{'text-green-400  ':!campaignMode,'text-grey-900':campaignMode}">{{ 'audit' | customerTerm:true }}</span>
            <span class="material-symbols-outlined ml-2 text-4xl"
              [ngClass]="{'text-green-400':!campaignMode,'text-grey-900':campaignMode}">
              checklist
            </span>
          </div>
          <div class="flex justify-center items-center  border-grey-500 border-[1px] w-1/2 hover:cursor-pointer   rounded-r-full px-4"
            [ngClass]="{'campaign-switcher':campaignMode}" (click)="showCampaign(true)">
            <span class="material-symbols-outlined text-grey-900 mr-2 text-4xl"
            [ngClass]="{'text-green-400':campaignMode,'text-grey-900':!campaignMode}">feedback</span>
            <span class="whitespace-nowrap"
              [ngClass]="{'text-green-400 ':campaignMode,'text-grey-900':!campaignMode}">Campaigns</span>
          </div>
        </div>
      </div>
    }
    <div class="p-2  mt-2 rounded-md border-2 "
      [ngClass]="{'border-grey-100  md:w-[20rem] flex justify-between':showAdditionalOptions,'border-standardwhite':!showAdditionalOptions}">
      @if (showAdditionalOptions) {
        <div class="">
          <p class="text-green-400 font-bold">Additional Options</p>
          <div class="mt-3">
            <div class="flex items-center " (click)="exportAllAuditResults()">
              <span class="material-symbols-outlined hover:cursor-pointer mr-1 text-green-700"
              (click)="switchAdditionalOptions()">download</span>
              <a class="hover:cursor-pointer hover:underline ">
                @if (!isExporting) {
                  <span>Download Full Details</span>
                }
                @if (isExporting) {
                  <span>Preparing Full Details {{exportProgress}}%</span>
                }
              </a>
            </div>
            @if (isExporting && exportStatus) {
              <p class="text-xs mt-2 text-grey-900">{{exportStatus}}</p>
            }
          </div>
        </div>
      }
      <span class="material-symbols-outlined hover:cursor-pointer text-2xl"
      (click)="switchAdditionalOptions()">more_vert</span>
    </div>


  </div>
  @if (campaignAuditResultView && !campaignResultLoading) {
    <div class="px-4 pt-4">
      <button (click)="unhideCampaignList()" class="btn-inverse mb-8">Back to results</button>
      <div>
        <app-campaign-detail [Campaign]="completedCampaign.Campaign"
        (GoToResult)="getCampaignAuditResult($event)"></app-campaign-detail>
      </div>
    </div>
  }
  @if (campaignAuditDetailView && !campaignResultLoading) {
    <div class="px-4 pt-4">
      <button (click)="unhideCampaignDetailList()" class="btn-inverse mb-8">Back to results</button>
      <div>
        <app-campaign-question-detail [Campaign]="campaignResultDetail"></app-campaign-question-detail>
      </div>
    </div>
  }
  <div class="px-2 md:px-6" [ngClass]="{'hidden':!showList}">
    <div class=" mb-2 border-grey-500 border-[1px] rounded-md p-3">
      <h3 class="">{{ 'audit' | customerTerm:true }}</h3>
      @if (!campaignMode) {
        <div>
          <div class="flex-col flex lg:flex-row justify-between">
            <select class="text-box w-full md:max-w-xl mt-2 mx-2 standardTextSize"
              [(ngModel)]="selectedAuditType" (change)="updateAudits()">
              @for (at of auditTypes; track at) {
                <option [ngValue]="at">{{at.Description}}</option>
              }
            </select>
            <select class="text-box w-full md:max-w-xl mx-2 lg:mx-0 mt-2 standardTextSize"
              [(ngModel)]="selectedFrequency" (change)="updateAudits()">
              @for (f of frequencies; track f) {
                <option [ngValue]="f">{{f.Description}}</option>
              }
            </select>
          </div>
          <select class="text-box w-full md:max-w-xl lg:mt-3 mt-2 mx-2 standardTextSize"
            [(ngModel)]="selectedAudit">
            @for (a of displayAudits ; track a) {
              <option [ngValue]="a">{{a.AuditName}}</option>
            }
          </select>
        </div>
      }
      @if (campaignMode) {
        <select class="text-box w-full md:max-w-xl lg:mt-3 mt-2 mx-2 standardTextSize"
          [(ngModel)]="selectedCampaignAudit">
          @for (a of displayCampaignAudits ; track a) {
            <option [ngValue]="a">{{a.AuditName}}</option>
          }
        </select>
      }
    </div>
    @if (!campaignMode) {
      <div class=" mb-2 border-grey-500 border-[1px] rounded-md p-3">
        <h3>Locations</h3>
        <div class="flex flex-col lg:flex-row justify-between  mt-2 px-2">
          <div class="text-box w-full md:max-w-xl mt-2 lg:mt-0">
            <p-select
              styleClass="w-full prime-input border-0"
              [options]="useLocationGroups ? locationGroupsWithAll : locations"
              optionLabel="LocationName"
              optionGroupLabel="label"
              optionGroupChildren="items"
              [group]="useLocationGroups"
              [pt]="{ label: { class: 'block w-full' } }"
              [filter]="true"
              filterBy="LocationName"
              [(ngModel)]="selectedLocation">
              <ng-template pTemplate="group" let-group>
                @if (group.label) {
                  <div class="font-semibold text-xs uppercase text-grey-500">
                    {{group.label}}
                  </div>
                }
              </ng-template>
              <ng-template pTemplate="selectedItem" let-location>
                <span class="block w-full">{{location?.LocationName}}</span>
              </ng-template>
            </p-select>
          </div>
          <div class="flex justify-start  items-center mt-4 lg:mt-0 lg:ml-4">
            <p>Include Sublocations:</p><app-toggle-switch [(checked)]="IncludeSubLocations"
          class="ml-2"></app-toggle-switch>
        </div>
      </div>
    </div>
  }
  @if (campaignMode) {
    <div class=" mb-2 border-grey-500 border-[1px] rounded-md p-3">
      <h3>Locations</h3>
      <div class="flex flex-col lg:flex-row justify-between  mt-2 px-2">
        <div class="text-box w-full md:max-w-xl mt-2 lg:mt-0">
          <p-select
            styleClass="w-full prime-input border-0"
            [options]="useCampaignLocationGroups ? campaignLocationGroupsWithAll : campaignLocations"
            optionLabel="Description"
            optionGroupLabel="label"
            optionGroupChildren="items"
            [group]="useCampaignLocationGroups"
            [pt]="{ label: { class: 'block w-full' } }"
            [filter]="true"
            filterBy="Description"
            [(ngModel)]="selectedCampaignLocation">
            <ng-template pTemplate="group" let-group>
              @if (group.label) {
                <div class="font-semibold text-xs uppercase text-grey-500">
                  {{group.label}}
                </div>
              }
            </ng-template>
            <ng-template pTemplate="selectedItem" let-location>
              <span class="block w-full">{{location?.Description}}</span>
            </ng-template>
          </p-select>
        </div>
        <div class="flex justify-start  items-center mt-4 lg:mt-0 lg:ml-4">
          <p>Include Sublocations:</p><app-toggle-switch [(checked)]="IncludeCampaignSubLocations"
        class="ml-2"></app-toggle-switch>
      </div>
    </div>
  </div>
}
<div class=" mb-2 border-grey-500 border-[1px] rounded-md p-3">
  <h3>Options</h3>


<div class="flex flex-col md:flex-row justify-between px-2">
  <div class="flex flex-col">
    <div>
      <div class="flex mt-2">
        <label class="mr-2">
          <p>Start Date:</p>
          <p-datepicker class="date-input" inputStyleClass="text-box" [(ngModel)]="startDate"
            (ngModelChange)="removeStartDateTimeZone($event)" dateFormat="dd M yy" [showIcon]="false"></p-datepicker>
          </label>
          <label class="mr-4">
            <p>End Date:</p>
            <p-datepicker class="date-input" inputStyleClass="text-box" [(ngModel)]="endDate"
              (ngModelChange)="removeEndDateTimeZone($event)" dateFormat="dd M yy" [showIcon]="false"></p-datepicker>
            </label>
          </div>

        </div>

      </div>
    </div>


  </div>

  <div class="">
    <button class="btn-primary mt-3 text-lg w-full md:w-auto" (click)="refreshSearch()"
      [disabled]="isLoading">@if (isLoading) {
      <span>Loading...</span>
      }@if (!isLoading) {
      <span>Load
      Results</span>
    }</button>
  </div>
  @if (validResultReturn && !campaignMode) {
    <div class=" px-2 mt-4">
      <div class="primary-green-border w-full border-grey-500 "></div>
    </div>
  }
  @if (validResultReturn && !campaignMode) {
    <div class="mt-4">
      <p class="px-4 font-bold text-sm mx-2">Summary of Selected {{ 'audit' | customerTerm:true }}</p>
      <div class="flex justify-stretch  mb-4 mx-2 lg:px-8">
        <div
          class="rounded-l-lg py-1 border-l-2 border-l-grey-500 border-y-2 border-y-grey-500 flex flex-col justify-center align-middle  w-1/3">
          <p class="text-center standardTextSize">Total {{ 'audit' | customerTerm:true }}</p>
          <p class=" text-center text-lg md:text-xl font-bold">{{totalAuditResults}}</p>
        </div>
        <div class="py-1 bg-danger-base flex flex-col justify-center align-middle w-1/3">
          <p class="text-standardwhite text-center standardTextSize">Overdue<span class="hidden md:contents">
          Actions</span></p>
          <p class="text-standardwhite text-center text-lg md:text-xl font-bold">{{overdueActions}}</p>
        </div>
        <div
          class="py-1 bg-green-700 text-standardwhite flex flex-col justify-center align-middle w-1/3 rounded-r-lg">
          <p class=" text-center standardTextSize"><span class="hidden md:contents">Actions </span>Completed
        </p>
        <p class="text-center text-lg md:text-xl font-bold">{{completedActions}}</p>
      </div>
    </div>
  </div>
}

@if (validResultReturn && !campaignMode) {
  <div class="mt-6 w-full px-2 md:px-4">
    <div class="flex justify-between align-middle mb-5">
      <h3 class="" #resultStart>Results</h3>
      <div class="flex flex-col items-end">
        @if (validSummary && totalAuditResults > maxAISummaryAudits) {
          <p class="ai-summary-limit-note">
            AI Summary can review up to {{maxAISummaryAudits}} audits. Please reduce the number of audits returned to use AI Summary.
          </p>
        }
        <div>
        <button class="btn-primary text-xs h-auto mr-2" (click)="generateSummary()"
          [disabled]="isSummarising || !canGenerateAISummary"
          [ngClass]="{'disabled':isSummarising || !canGenerateAISummary, 'hidden': !validSummary}">@if (!isSummarising) {
          <span
          >AI Summary</span>
          } @if (isSummarising) {
          <span
          >Summarising...</span>
        }
        <!--<span class="material-symbols-outlined h-4 w-4">stars_2</span>--> </button>
        <button class="btn-inverse h-auto text-xs" [ngClass]="{'pointer':isExporting||isLoading}"
          (click)="exportSelection()" [disabled]="(isExporting || isLoading)">@if (!isExporting) {
          <span
          >Export</span>
          }@if (isExporting) {
          <span
          >Exporting...</span>
          }<span></span></button>
        </div>
      </div>
    </div>
      @for (a of auditResultList; track a) {
        <div class="">
          <app-audit-result [audit]="a"
          (resetNewAction)="getAudit(a.AuditCompletionInfo.AuditResultID)"></app-audit-result>
        </div>
      }
      @if (totalResultCount > pageSize && !campaignMode) {
        <div class="mt-4 paginator-wrapper" [ngClass]="{'pointer-events-none opacity-70': isLoading}">
          <p-paginator
            [first]="firstResult"
            [rows]="pageSize"
            [totalRecords]="totalResultCount"
            [rowsPerPageOptions]="pageSizeOptions"
            (onPageChange)="onResultsPageChange($event)">
          </p-paginator>
        </div>
      }
      @if (campaignResultLoading) {
        <div>
          <p>Loading...</p>
        </div>
      }
      @if ((!validResultReturn && !campaignMode) || (campaignMode && !validCampaignReturn)) {
        <div class="mt-4">
          <p>No results for selected criteria.</p>
        </div>
      }
    </div>
  }

  @if (validCampaignReturn && campaignMode &&!campaignAuditResultView) {
    <div>
      @if (!showKey) {
        <div class="my-2 rounded-lg ">
          <span
            class="material-symbols-outlined text-3xl  align-bottom text-green-700 self-center  px-1 hover:cursor-pointer"
          (click)="changeHelp()">info</span>
        </div>
      }
      @if (showKey) {
        <div class="my-2 ">
          <div class="border-4 border-green-50 rounded-lg flex flex-col">
            <div class="flex justify-start">
              <span
                class="material-symbols-outlined text-3xl  align-bottom text-green-700 self-center  px-1 hover:cursor-pointer"
              (click)="changeHelp()">info</span>
            </div>
            <div class="flex flex-col w-full pb-3">
              <div class="flex flex-col lg:flex-row justify-center ">
                <div class="flex flex-col justify-center items-center lg:mr-2 mt-2 lg:mt-0 lg:w-1/4">
                  <span class="material-symbols-outlined text-green-400 text-4xl">mail</span>
                  <p class="text-sm text-center">Email Sent</p>
                </div>
                <div class="flex flex-col justify-center items-center mt-2 lg:mt-0 lg:w-1/4">
                  <span class="material-symbols-outlined text-green-400 text-4xl">eyeglasses_2</span>
                  <p class="text-sm text-center">Accessed Link</p>
                </div>
                <div class="flex flex-col justify-center items-center lg:ml-2 lg:w-1/4">
                  <span class="material-symbols-outlined text-green-400 text-4xl">check</span>
                  <p class="text-sm text-center">Submitted Results</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="mt-4 mb-3 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        <h3>Feedback Responses</h3>
        <div class="flex flex-col items-start md:items-end">
          @if (validSummary && totalAuditResults > maxAISummaryAudits) {
            <p class="ai-summary-limit-note">
              AI Summary can review up to {{maxAISummaryAudits}} audits. Please reduce the number of audits returned to use AI Summary.
            </p>
          }
          <button class="btn-primary text-xs h-auto" (click)="generateSummary()"
            [disabled]="isSummarising || !canGenerateAISummary"
            [ngClass]="{'disabled':isSummarising || !canGenerateAISummary, 'hidden': !validSummary}">
            @if (!isSummarising) {
              <span>AI Summary</span>
            } @if (isSummarising) {
              <span>Summarising...</span>
            }
          </button>
        </div>
      </div>
      @for (c of campaignResultReturn.Campaigns; track c.AuditRequestID) {
        <div>
          <app-campaign-result (click)="switchToResult(c)" [campaign]="c"></app-campaign-result>
        </div>
      }
    </div>
  }

</div>



<div [ngClass]="{'hidden':!showAISummary}" class="mt-5 lg:ml-8 p-2">
  <div class="mx-12 mb-7">
    <button (click)="unhideList()" class="btn-inverse mb-8">Back to results</button>

    <h2 class="mb-4">Completed {{ 'audit' | customerTerm }} Summary</h2>

    <h6 class="text-xs text-grey-900">{{ 'audit' | customerTerm }}</h6>
    <p class="font-bold">{{currentRequest.AuditName}}</p>
    <h6 class="text-xs text-grey-900">{{ 'audit' | customerTerm }} Type</h6>
    <p class="font-bold">{{getAuditTypeName(currentRequest.AuditTypeID)}}</p>
    <h6 class="text-xs text-grey-900">{{ 'audit' | customerTerm }} Frequency</h6>
    <p class="font-bold">{{getAuditFrequencyName(currentRequest.AuditFrequencyID)}}</p>
    <h6 class="text-xs text-grey-900">Location</h6>
    <p class="font-bold">{{currentRequest.LocationName}} @if (currentRequest.IncludeSubLocations) {
      <span>
      (including sublocations)</span>
    }</p>
    <p class="pt-2">{{ 'audit' | customerTerm:true }} completed between <strong>{{displayDate(currentRequest.StartDate)}}</strong> and
    <strong>{{displayDate(currentRequest.EndDate)}}</strong>
  </p>

  <p class="text-center text-xs my-8">These results have been generated by AI. Please verify the correctness
  of information provided before actioning.</p>
  @if (false) {
    <div class="border-grey-500 border-2 rounded-xl">
    </div>
  }
  <div [ngClass]="{'justify-center':showAITips}" class="flex items-center mb-4 mt-1">
    <div [ngClass]="{'p-3 justify-start':showAITips}"
      class=" flex p-1 rounded-lg border-grey-500 border-2 w-full  items-center">
      <span [ngClass]="{'md:px-4 px-2 mr-1':showAITips}"
        class="material-symbols-outlined text-3xl  align-bottom text-green-700 self-center  px-1 cursor-pointer"
      (click)="switchAITips()">info</span>
      <div class="flex flex-col">
        <h2 class="text-green-400 text-xl ">AI Top Tips</h2>
        @if (showAITips) {
          <div class="flex flex-col">
            <p class="text-green-400 mt-2 text-sm">More {{ 'audit' | customerTerm:true }} for Better Insights</p>
            <p class=" text-sm">{{ 'The AI works best with more data. The more audits you add, the sharper the analysis!' | customerText }}</p>
            <p class="text-green-400 mt-2 text-sm">Based Only on What You Provide</p>
            <p class=" text-sm">It looks <strong class=" text-sm">only</strong> at the {{ 'audits' | customerText }}
            you&#8217;ve uploaded, it won&#8217;t use
            outside
            info
          or past trends.</p>
          <p class="text-green-400 mt-2 text-sm">Occasionally Overconfident</p>
          <p class=" text-sm">If something sounds a bit off, it might be a rare <span
          class="text-sm italic">“hallucination”</span>, feel free to question it!
        </p>
        <p class="text-green-400 mt-2 text-sm">Ask Specific Questions</p>
        <p class=" text-sm">Targeted questions get more useful answers. Think <span
          class="italic text-sm">"themes in medication
          errors"</span> not just <span class="italic text-sm">"any issues?"</span></p>
          <p class="text-green-400 mt-2 text-sm">You&#8217;re the Expert</p>
          <p class=" text-sm">AI is here to support your insight, not replace it. <span
          class="text-sm font-bold">Your judgement still leads the way!</span></p>
        </div>
      }

    </div>

  </div>
</div>
<div class="ai-heading ai-content"></div>
<div [innerHTML]="summaryResults" class="aiSummary">
</div>
@if (aiSummaryRetryAvailable && !isSummarising) {
  <div class="ai-summary-retry">
    @if (aiSummaryRetryCountdown > 0) {
      <p class="ai-summary-retry-message">Retry available in {{aiSummaryRetryCountdown}} seconds.</p>
    }
    <button class="btn-primary h-auto text-xs" [disabled]="aiSummaryRetryCountdown > 0"
      [ngClass]="{'disabled': aiSummaryRetryCountdown > 0}" (click)="retryAISummary()">{{aiSummaryRetryButtonLabel}}</button>
  </div>
}
@if (aiSummaryStartNewChatAvailable && !isSummarising) {
  <div class="ai-summary-retry">
    <button class="btn-primary h-auto text-xs" (click)="startNewAIChat()">Start new AI chat</button>
  </div>
}
@if (showAISummaryLoadingIndicator) {
  <div class="flex align-middle items-center">
    <div class="spinner"></div>
    <div class="ml-4">
      @if (aiSummaryLoadingMessage) {
        <h4 class="font-bold text-base text-grey-900 m-0">{{aiSummaryLoadingMessage}}</h4>
      }
    </div>
  </div>
}
@if (hasAISummaryResponse && aiSummaryMode == 'quick' && !isSummarising && !aiSummaryRetryAvailable && !aiSummaryStartNewChatAvailable) {
<div class="ai-summary-deep-dive">
  <textarea [(ngModel)]="prompt" rows="3" class="w-full lg:max-w-1/2"
    placeholder="Optional focus for the deep dive"></textarea>
  <button class="btn-primary h-auto ml-0 md:ml-8 mt-3 md:mt-0" (click)="generateSummary()">Deep dive</button>
</div>
}

</div>

</div>

<div [ngClass]="{'hidden':!showResults}" class="mt-5">
  <div class="mx-12 mb-7 flex justify-between print-hidden results-toolbar">
    <button (click)="returnFromResultDetail()" class="btn-inverse results-toolbar-back">{{resultBackLabel()}}</button>
    <div class="results-toolbar-actions">
      <button class="btn-inverse h-auto text-xs mr-3" (click)="showActionPanel()">Action Summary</button>
      <button class="btn-inverse h-auto text-xs mr-3" (click)="printAudit()">Print</button>
      <button class="btn-inverse h-auto text-xs" (click)="exportFullAudit()">Export</button>
    </div>

  </div>
  <div class="px-8 print-no-padding">
    <app-audit-result-detail [auditResultDetail]="auditResultDetail"></app-audit-result-detail>
  </div>

</div>
<div [ngClass]="{'hidden':!showActions}" class="mt-5">
  <div class="mx-12 mb-7 flex justify-between print-hidden results-toolbar">
    <button (click)="hideActionPanel()" class="btn-inverse results-toolbar-back">Back to result</button>
    <div class="results-toolbar-actions">
      <button class="btn-inverse h-auto text-xs mr-3" (click)="printActionsPanel()">Print</button>
    </div>
  </div>
  <div class="px-8 print-no-padding">
    <app-results-action-panel [auditResultDetail]="auditResultDetail"></app-results-action-panel>
  </div>

</div>

</div>
